import { CommonAction } from '../../../login/redux/types';
import { getFilterData } from '../utils';
import InvestmentTypes, { InvestmentState } from './types';

const investmentsInitialState: InvestmentState = {
    investments: [],
    loading: false,
    repayment: undefined,
    detailLoading: false,
    executedAgreementsLoading: false,
    updatesLoading: false,
    repayments: [],
    performancesLoading: false,
    distributionLoading: false,
    reportingObligations: [],
    rLoading: false,
    cashflow: [],
    cLoading: false,
    guarantees: [],
    gLoading: false,
    security: [],
    sLoading: false,
    covenant: [],
    coLoading: false,
    aggregate: undefined,
    aLoading: false,
    filterData: {
        dealName: [],
        dealType: [],
        instrumentType: [],
        interestRate: [],
        issuerName: [],
        status: [],
    },
    loadingUpdate: false,
    updatePortfolioDoc: [],
    eloading: false,
    executedAgreementsDoc: [],
};

const InvestmentReducer = (state = investmentsInitialState, action: CommonAction): InvestmentState => {
    switch (action.type) {
        case InvestmentTypes.GET_INVESTMENTS_REQ:
            return {
                ...state,
                investments: [],
                loading: true,
            };
        case InvestmentTypes.SET_INVESTMENTS:
            return {
                ...state,
                investments: action.payload,
                filterData: getFilterData(action.payload),
                loading: false,
            };
        case InvestmentTypes.FETCH_REPAYMENT_REQ:
            return {
                ...state,
                loading: true,
                repayments: [],
            };
        case InvestmentTypes.SET_REPAYMENT:
            return {
                ...state,
                loading: false,
                repayments: action.payload || [],
            };
        case InvestmentTypes.FETCH_INVESTMENT_DETAILS:
            return {
                ...state,
                detailLoading: true,
                investmentDetails: undefined,
            };
        case InvestmentTypes.SET_INVESTMENT_DETAILS:
            return {
                ...state,
                detailLoading: false,
                investmentDetails: action.payload || undefined,
            };
        case InvestmentTypes.FETCH_EXECUTED_AGREEMENTS:
            return {
                ...state,
                executedAgreements: undefined,
                executedAgreementsLoading: true,
            };
        case InvestmentTypes.SET_EXECUTED_AGREEMENTS:
            return {
                ...state,
                executedAgreementsLoading: false,
                executedAgreements: action.payload || undefined,
            };
        case InvestmentTypes.FETCH_UPDATED_OR_REPORTIES:
            return {
                ...state,
                updatesLoading: true,
                updates: undefined,
            };
        case InvestmentTypes.SET_UPDATED_OR_REPORTIES:
            return {
                ...state,
                updatesLoading: false,
                updates: action.payload || undefined,
            };
        case InvestmentTypes.FETCH_PERFORMANCES:
            return {
                ...state,
                performancesLoading: true,
                performances: undefined,
            };
        case InvestmentTypes.SET_PERFORMANCES:
            return {
                ...state,
                performancesLoading: false,
                performances: action.payload,
            };
        case InvestmentTypes.FETCH_DISTRIBUTION:
            return {
                ...state,
                distributionLoading: true,
                distributions: undefined,
            };
        case InvestmentTypes.SET_DISTRIBUTION:
            return {
                ...state,
                distributionLoading: false,
                distributions: action.payload,
            };
        case InvestmentTypes.SET_PPM:
            return {
                ...state,
                ppm: action.payload,
            };
        case InvestmentTypes.FETCH_REPORTING_OBLIGATION:
            return {
                ...state,
                rLoading: true,
                reportingObligations: [],
            };
        case InvestmentTypes.SET_REPORTING_OBLIGATION:
            return {
                ...state,
                rLoading: false,
                reportingObligations: action.payload,
            };
        case InvestmentTypes.FETCH_CASHFLOW:
            return {
                ...state,
                cLoading: true,
                cashflow: [],
            };
        case InvestmentTypes.SET_CASHFLOW:
            return {
                ...state,
                cashflow: action.payload,
                cLoading: false,
            };
        case InvestmentTypes.FETCH_GUARANTEES:
            return {
                ...state,
                guarantees: [],
                gLoading: true,
            };
        case InvestmentTypes.SET_GUARANTEES:
            return {
                ...state,
                guarantees: action.payload,
                gLoading: false,
            };
        case InvestmentTypes.FETCH_SECURITIES:
            return {
                ...state,
                security: [],
                sLoading: true,
            };
        case InvestmentTypes.SET_SECURITIES:
            return {
                ...state,
                security: action.payload,
                sLoading: false,
            };
        case InvestmentTypes.FETCH_COVENANTS:
            return {
                ...state,
                coLoading: true,
                covenant: [],
            };
        case InvestmentTypes.SET_COVENANTS:
            return {
                ...state,
                coLoading: false,
                covenant: action.payload,
            };
        case InvestmentTypes.FETCH_AGGREGATE:
            return {
                ...state,
                aggregate: undefined,
                aLoading: true,
            };

        case InvestmentTypes.SET_AGGREGATE:
            return {
                ...state,
                aggregate: action.payload,
                aLoading: false,
            };
        case InvestmentTypes.FETCH_UPDATE_DOCUMENTS:
            return {
                ...state,
                loadingUpdate: true,
                updatePortfolioDoc: [],
            };
        case InvestmentTypes.SET_UPDATE_DOCUMENTS:
            return {
                ...state,
                loadingUpdate: false,
                updatePortfolioDoc: action.payload,
            };
        case InvestmentTypes.FETCH_INVESTMENT_EXECUTED_AGREEMENTS:
            return {
                ...state,
                eloading: true,
                executedAgreementsDoc: [],
            };
        case InvestmentTypes.SET_INVESTMENT_EXECUTED_AGREEMENTS:
            return {
                ...state,
                eloading: false,
                executedAgreementsDoc: action.payload,
            };
        default:
            return state;
    }
};

export default InvestmentReducer;
